// extracted by mini-css-extract-plugin
export default {"label":"_12ce5cb2"};